import React, { useRef } from "react";
import { Button, Select } from "antd";

const CustomFilterDropdown = ({
    options,
    selectedKeys,
    setSelectedKeys,
    confirm,
    clearFilters,
    placeholder = "Search...",
    loading
}) => {
    const selectRef = useRef(null);
    
    const handleReset = () => {
        clearFilters && clearFilters();
        // Close the Select dropdown
        if (selectRef.current) {
            selectRef.current.blur();
        }
        // Close the filter dropdown
        confirm();
    };
    
    const handleApply = () => {
        // Close the Select dropdown
        if (selectRef.current) {
            selectRef.current.blur();
        }
        // Close the filter dropdown
        confirm();
    };
    
    return (
        <div style={{ padding: 8, width: 280 }}>
            <Select
                ref={selectRef}
                mode="multiple"
                placeholder={placeholder}
                value={selectedKeys}
                onChange={setSelectedKeys}
                showSearch
                style={{
                    width: '100%',
                    marginBottom: 8
                }}
                filterOption={(input, option) =>
                    option?.children?.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                maxTagCount="responsive"
                allowClear={false}
                loading={loading}
                dropdownRender={menu => (
                    <>
                        {menu}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            gap: 8,
                            padding: '8px',
                            borderTop: '1px solid #f0f0f0'
                        }}>
                            <Button
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    setSelectedKeys([]);
                                }}
                                style={{ flex: 1 }}
                            >
                                Reset
                            </Button>
                            <Button
                                type="primary"
                                size="small"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    handleApply();
                                }}
                                style={{ flex: 1 }}
                            >
                                Apply
                            </Button>
                        </div>
                    </>
                )}
                getPopupContainer={trigger => trigger.parentElement}
            >
                {options.map(option => (
                    <Select.Option key={option} value={option}>
                        {option}
                    </Select.Option>
                ))}
            </Select>
            
            <div style={{ display: "flex", justifyContent: "space-between", gap: 8 }}>
                <Button
                    size="small"
                    style={{ flex: 1 }}
                    onClick={handleReset}
                >
                    Reset
                </Button>
                <Button
                    type="primary"
                    size="small"
                    style={{ flex: 1 }}
                    onClick={handleApply}
                >
                    Apply
                </Button>
            </div>
        </div>
    );
};

export default CustomFilterDropdown;